import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { adminApi } from "../../lib/adminApi";
import { toast } from "sonner";

export default function PromptDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ name: "", template: "" });

  const fetchPrompt = async () => {
    try {
      const data = await adminApi.getPrompt(id);
      setPrompt(data);
      setForm({ name: data.name, template: data.template });
    } catch (e) {
      toast.error(e.message);
    }
    setLoading(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchPrompt(); }, [id]);

  const handleUpdate = async () => {
    try {
      await adminApi.updatePrompt(id, form);
      toast.success("Prompt updated");
      fetchPrompt();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const handleRestore = async (version) => {
    try {
      await adminApi.restorePromptVersion(id, version);
      toast.success("Version restored");
      fetchPrompt();
    } catch (e) {
      toast.error(e.message);
    }
  };

  if (loading) return <div className="text-center py-8">Loading...</div>;
  if (!prompt) return <div className="text-center py-8">Prompt not found</div>;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Prompt: {prompt.slug}</h1>
        <Button variant="outline" onClick={() => navigate("/admin/prompts")}>Back</Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader><CardTitle>Edit Prompt</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <div>
              <label className="text-sm font-medium">Name</label>
              <Input value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} />
            </div>
            <div>
              <label className="text-sm font-medium">Template</label>
              <Textarea rows={12} value={form.template} onChange={(e) => setForm({...form, template: e.target.value})} />
            </div>
            <Button onClick={handleUpdate} className="w-full">Save Changes</Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader><CardTitle>Version History ({prompt.versions?.length || 0})</CardTitle></CardHeader>
          <CardContent>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Version</TableHead>
                  <TableHead>Changed By</TableHead>
                  <TableHead>Date</TableHead>
                  <TableHead>Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {prompt.versions?.map((v) => (
                  <TableRow key={v.id}>
                    <TableCell>v{v.version}</TableCell>
                    <TableCell>{v.changed_by}</TableCell>
                    <TableCell>{new Date(v.created_at).toLocaleString()}</TableCell>
                    <TableCell>
                      <Button variant="outline" size="sm" onClick={() => handleRestore(v.version)}>
                        Restore
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
